// services/accountService.js
import api from "./api";

export const getMyAccount = async () => {
  try {
    const response = await api.get("/account/me/");
    return response.data;
  } catch (error) {
    console.error("Error fetching account details:", error);
    throw error;
  }
};

export const updateAccount = async (data) => {
  try {
    const response = await api.patch("/account/me/", data);
    return response.data;
  } catch (error) {
    console.error("Error updating account:", error);
    throw error;
  }
};

export const deleteAccount = async () => {
  try {
    const response = await api.post("/account/delete-account/");
    return response.data;
  } catch (error) {
    console.error("Error deleting account:", error);
    throw error;
  }
};

export const changePassword = async (data) => {
  try {
    const response = await api.post("/account/change-password/", data);
    return response.data;
  } catch (error) {
    console.error("Error changing password:", error);
    throw error;
  }
};
